import axios from "axios";
import { toast } from "react-toastify";
import superAdminAuthHeader from "./superAdminAuthHeader";

export const testRemoteConnection = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/company-migration/test-connection`,
        data,
        { headers: superAdminAuthHeader() }
      )
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const migrateCompanyData = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/company-migration/migrate`,
        data,
        {
          headers: superAdminAuthHeader(),
          timeout: 600000, // 10 min timeout for large migrations
        }
      )
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
